<template>
    <div class="home-container">
        <div class="header">
            <div class="logo">客户管理系统</div>
            <div class="userinfo">
                <el-dropdown trigger="click">
					<span class="el-dropdown-link userinfo-inner btn" style="color:#fff">
						{{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="updateForm()">修改密码</el-dropdown-item>
                        <!-- <el-dropdown-item @click.native="">个人信息</el-dropdown-item>
                        <el-dropdown-item @click.native="">帮助</el-dropdown-item> -->
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="content">
            <aside :class="{ 'toogleNav': toogleMenu}">
                <el-menu :default-active="$route.path" class="el-menu-vertical-demo" text-color="#fff">
                    <el-menu-item index="1" @click="getRouter(homePage.path)"
                                  :class="{ 'is-active': checkActive('/' + homePage.path) }">
                        <i class="el-icon-menu"></i>
                        <span slot="title">首页</span>
                    </el-menu-item>
                    <div v-for="(item,index) in menuList" :key="index">
                        <el-submenu
                                :index="index+''">
                            <template slot="title">
                                <i :class="'wz ' + item.icon"></i>
                                <span class="menu-name">{{item.name}}</span>
                            </template>
                            <el-menu-item @click="getRouter(child.path)"
                                          :class="{ 'is-active': checkActive('/' + child.path) }"
                                          v-for="(child,index) in item.children" :index="'/' + child.path" :key="index">
                                <span class="menu-name">{{child.name}}</span>
                            </el-menu-item>
                        </el-submenu>
                    </div>
                </el-menu>
            </aside>
            <section :class="['content-container',{ 'toogleContent' : toogleMenu }]">
                <div class="grid-content bg-purple-light">
                    <div class="tabs-toogle">
                        <el-tabs v-model="editableTabsValue" type="card" @tab-click="toogleTabs"
                                 @tab-remove="removeTab">
                            <el-tab-pane v-for="item in editableTabs" :closable="item.name != '/count'" :key="item.name"
                                         :label="item.title" :name="item.name"></el-tab-pane>
                        </el-tabs>
                        <el-popover class="closeBtn" placement="bottom-end" width="120" trigger="click"
                                    v-model="dVisible">
                            <ul class="closeBtn-list">
                                <li @click="closeTabs(1)">关闭当前标签页</li>
                                <li @click="closeTabs(2)">关闭其他标签页</li>
                                <li @click="closeTabs(3)">关闭全部标签页</li>
                            </ul>
                            <el-button slot="reference" type="text" size="small" icon="el-icon-arrow-down"></el-button>
                        </el-popover>
                    </div>
                    <div class="breadcrumb-container">
                        <i class="refresh wz icon-shuaxin fr btn" @click="refresh"></i>
                        <el-breadcrumb separator="/" class="breadcrumb-inner">
                            <el-breadcrumb-item v-for="(item,index) in $route.matched" :key="index">
                                {{ item.name }}
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>
                <div class="content-wrapper">
                    <keep-alive :include="includedComponents">
                        <router-view></router-view>
                    </keep-alive>
                </div>
            </section>
            <div class="slide" :class="{ 'on': toogleMenu}" @click="toogleMenu = !toogleMenu"></div>
        </div>

        <!-- 修改密码 -->
        <el-dialog title="修改密码" width="30%" :visible.sync="aVisible" top="7vh" :modal-append-to-body="false"
                   :close-on-click-modal="false">
            <el-form :model="formData" v-loading="fLoading" label-width="100px" :rules="formRules" ref="formFileds">
                <el-form-item label="用户名:" prop="username">
                    <el-input v-model="formData.username"></el-input>
                </el-form-item>
                <el-form-item label="原密码" prop="oldPassword">
                    <el-input v-model="formData.oldPassword" type="password"></el-input>
                </el-form-item>
                <el-form-item label="新密码:" prop="newPassword">
                    <el-input v-model="formData.newPassword" type="password" :show-password="true"
                              placeholder="包含大小写字母、数字"></el-input>
                </el-form-item>
                <el-form-item label="确认密码:" prop="doPsd">
                    <el-input v-model="formData.doPsd" type="password" :show-password="true"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="aVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveSubmit()" :loading="bLoading">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                updatePasswordUrl: '/update/password',
                homePage: {name: "首页", icon: '', path: 'count'},
                menuList: [
                    {
                        name: '客户管理', icon: '', children: [
                            {path: 'khlb', name: '客户列表', icon: ''},
                            {path: 'gzjl', name: '跟踪记录', icon: ''},
                            {path: 'ghlb', name: '供应商列表', icon: ''},
                            {path: 'jxlb', name: '经销商列表', icon: ''},
                        ]
                    },
                    {
                        name: '商品管理', icon: '', children: [
                            {path: 'splb', name: '注册产品列表', icon: ''},
                            {path: 'spjg', name: '商品价格列表', icon: ''}
                        ]
                    },
                    {
                        name: '系统管理', icon: '', children: [
                            {path: 'bmzd', name: '编码字典', icon: ''},
                        ]
                    },
                ],
                toogleMenu: false,
                editableTabsValue: '',
                editableTabs: [],
                includedComponents: '',
                userName: 'admin',

                formData: {
                    username: '',
                    oldPassword: '',
                    newPassword: '',
                    doPsd: '',
                },
                formRules: {
                    oldPassword: [
                        {required: true, message: '请输入原密码', trigger: 'blur'},
                    ],
                    newPassword: [
                        {required: true, message: '请输入新密码', trigger: 'blur'},
                        {validator: this.validPwd, trigger: 'blur'}
                    ],
                    doPsd: [
                        {required: true, message: '请输入确认密码', trigger: 'blur'},
                        {validator: this.validPwd, trigger: 'blur'},
                        {validator: this.confirmPass, trigger: 'blur'}
                    ]
                },
            }
        },
        computed: {
            ...mapGetters(['username'])
        },
        watch: {
            '$route': 'fetchData',
            editableTabs(tabs) {
                this.includedComponents = tabs.map(item => item.name.substr(1)).toString()
            }
        },
        methods: {
            getRouter(href) {
                if (this.$route.path.substring(1).split('/')[0] == href) return
                this.$router.push('/' + href)
            },
            removeTab(targetName) {
                let tabs = this.editableTabs;
                let activeName = this.editableTabsValue;
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                activeName = nextTab.name;
                                this.$router.push(activeName)
                            }
                        }
                    })
                }
                this.editableTabsValue = activeName
                this.editableTabs = tabs.filter(tab => tab.name !== targetName)
            },
            fetchData() {
                var title = this.$route.name
                var name = this.$route.path
                if (name == '/reload') {
                    this.$router.go(-1)
                    return
                } else {
                    let o = this.$route.path.substring(1).split('/');
                    if (o.length > 1) {
                        title = this.$route.matched[1].name
                        name = this.$route.matched[1].path
                    }
                    this.editableTabsValue = name
                    let ar = this.includedComponents.split(',');
                    if (this.includedComponents.indexOf(name.substr(1)) == -1) {
                        ar.push(name.substr(1))
                        this.includedComponents = ar.toString()
                    }
                    if (!this.editableTabs.some(item => item.name == name)) {
                        this.editableTabs.push({
                            title: title,
                            name: name
                        })
                    }
                }
            },
            checkActive(name) {
                return this.editableTabsValue == name;
            },
            // 点击标签页跳转到指定模块
            toogleTabs(item) {
                if ('/' + this.$route.path.substring(1).split('/')[0] == item.name) return
                this.$router.push(item.name)
            },
            refresh() {
                let name = this.$route.path;
                let str = this.includedComponents;
                if (name.split('/').length == 3) {
                    name = name.split('/')[2]
                    let time = new Date();
                    this.$store.commit('setRefresh', {
                        name: name,
                        time: time.getTime()
                    })
                } else {
                    this.includedComponents = str.split(',').filter(item => item !== name.substr(1)).toString()
                    this.$router.push('/reload')
                }
            },

            // 关闭标签页
            closeTabs(type) {
                switch (type) {
                    case 1:
                        if (this.editableTabsValue == '/count') {
                            this.$message({message: '首页不可关闭', type: 'warning'})
                            return;
                        }
                        this.removeTab(this.editableTabsValue)
                        break;
                    case 2:
                        this.editableTabs = this.editableTabs.filter(item => item.name == this.editableTabsValue || item.name == '/count');
                        this.includedComponents = this.editableTabs.map(item => item.name.substr(1)).toString()
                        break;
                    case 3:
                        this.editableTabs = this.editableTabs.filter(item => item.name == '/count');
                        this.includedComponents = 'count'
                        this.editableTabsValue = '/count'
                        this.$router.push('/count')
                        break;
                }
                this.dVisible = false;
            },

            // 修改密码
            updateForm() {
                this.aVisible = true;
                this.$nextTick(() => {
                    this.$refs.formFileds.resetFields();
                    this.formData.id = this.systemUser.id
                })
            },
            //  保存
            saveSubmit() {
                this.$refs.formFileds.validate((valid) => {
                    if (valid) {
                        this.$confirm('修改密码后下次登录生效！确认修改吗？', '提示', {}).then(() => {
                            let para = Object.assign({}, this.formData);
                            this.bLoading = true
                            this.request(this.updatePasswordUrl, para, (data) => {
                                this.$message({message: '提交成功', type: 'success'})
                                this.aVisible = false
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        })
                    }
                })
            },

            //验证密码
            validPwd(rule, value, callback) {
                if (value === '') {
                    callback()
                    return
                }
                if (value.length < 5 || value.length > 20) {
                    callback(new Error('密码长度为5至20位'))
                    return
                }
                let regular = /^[a-zA-Z0-9]+$/;
                if (!regular.test(value)) {
                    callback(new Error('只允许输入英文或数字'))
                } else {
                    callback()
                }
            },
            confirmPass(rule, value, callback) {
                if (value === '') {
                    callback()
                    return
                }
                if (value !== this.formData.newPassword) {
                    callback(new Error('两次输入密码不一致'))
                } else {
                    callback()
                }
            },
        },
        created() {
            var title = this.$route.name
            var name = this.$route.path
            this.editableTabsValue = name
            this.editableTabs.push({
                title: title,
                name: name
            })
            this.setStoreData(this.sysUrl, {type: 'CUSTOMER_TYPE'}, 'setType'); //类型
            this.setStoreData(this.sysUrl, {type: 'CUSTOMER_LEVEL'}, 'setLevel'); //等级
            this.setStoreData(this.sysUrl, {type: 'CUSTOMER_SOURCE'}, 'setSource'); //来源
            this.setStoreData(this.sysUrl, {type: 'CUSTOMER_TRACK_STATUS'}, 'setStatus'); //跟踪状态
            this.setStoreData(this.sysUrl, {type: 'CUSTOMER_STATUS'}, 'setCustomerStatus'); //客户状态
            this.setStoreData(this.sysUrl, {type: 'PRODUCT_TYPE'}, 'setProductType'); //产品类型
        },
        mounted() {
            this.$store.commit('setUserName', JSON.parse(sessionStorage.getItem('loginData')).username)
        }
    }
</script>

<style lang="less">
    .home-container {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%;

        .header {
            height: 62px;
            line-height: 60px;
            background: url(../assets/images/headerBg.jpg) repeat-x;
            color: #c0ccda;

            .userinfo {
                text-align: right;
                padding-right: 20px;
                height: 62px;
                float: right;
                align-items: center;
                color: #fff;

                span {
                    display: inline-block;
                    color: #fff;
                    margin: 0 10px;
                    vertical-align: top;
                    font-size: 1.2em;
                    line-height: 62px;
                    cursor: pointer;
                }

                .icon-084tuichu {
                    cursor: pointer;
                    vertical-align: middle;
                    margin: 0 10px;
                }

                .item {
                    margin-top: 10px;
                }

                .el-badge__content.is-fixed {
                    top: 20px;
                    right: 17px;
                }

                .el-badge,
                .el-dropdown {
                    line-height: 62px;
                    vertical-align: top;
                    font-size: 1em;
                }
            }

            .logo {
                float: left;
                padding-left: 20px;
                line-height: 62px;
                font-size: 24px;
                font-family: '黑体';
                color: #fff;
                letter-spacing: 3px;
            }
        }

        .content {
            position: absolute;
            top: 62px;
            bottom: 0px;
            right: 0px;
            left: 0px;
            overflow: hidden;

            .content-container {
                position: absolute;
                right: 0;
                top: 0px;
                bottom: 0px;
                left: 170px;
                overflow: hidden;
                transition: left 0.3s ease-in-out;

                .tabs-toogle {
                    position: relative;
                    background-color: #fff;
                    padding: 5px;
                    padding-bottom: 0;

                    .el-tabs__nav-wrap {
                        margin-right: 40px;
                    }

                    .el-tabs__item {
                        height: 35px;
                        line-height: 35px;
                    }

                    .closeBtn {
                        position: absolute;
                        right: 10px;
                        bottom: 0;

                        i {
                            font-size: 1.4em;
                        }
                    }
                }

                .grid-content {
                    position: relative;
                    padding: 5px;
                    background: #fff;
                    z-index: 2;
                }

                .breadcrumb-container {
                    padding: 5px 5px 0;
                    line-height: 30px;
                    background-color: #fff;

                    i {
                        color: #409EFF;
                        font-size: 1.4em;
                    }

                    .el-icon-caret-left,
                    .el-icon-caret-right {
                        font-size: 20px;
                        cursor: pointer;
                    }

                    .breadcrumb-inner {
                        display: inline-block;
                        color: #475669;
                        padding: 0 20px 0 8px;
                        border-left: 2px solid #20a0ff;
                    }
                }

                .content-wrapper {
                    position: absolute;
                    top: 72px;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    overflow: hidden;
                }

                &.toogleContent {
                    left: 0;
                }
            }

            aside {
                position: absolute;
                left: 0;
                top: 0;
                width: 170px;
                height: 100%;
                overflow: hidden;
                transition: left 0.3s ease-in-out;

                .menu-txt {
                    display: flex;
                    height: 62px;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                }

                .el-menu-vertical-demo {
                    width: 190px;
                    padding-right: 20px;
                    padding-top: 2px;
                    overflow-x: hidden;
                    overflow-y: auto;
                }

                .tipbox {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    display: inline-block;
                    text-align: center;
                    cursor: pointer;
                    font-size: 16px;
                    color: #fff;
                }

                .el-menu {
                    height: 100%;
                    background: #0d3768;
                }

                .el-submenu__icon-arrow {
                    width: 12px;
                }

                .el-submenu {
                    width: 170px;
                    margin-bottom: 2px;

                    .el-menu-item {
                        min-width: auto;
                        height: 40px;
                        line-height: 40px;
                    }

                    span {
                        line-height: 40px;
                    }
                }

                .el-submenu__title {
                    height: 40px;
                    display: flex;
                    align-items: center;
                    color: #fff;
                    padding-left: 0 !important;
                    background-color: rgba(8, 108, 167, 0.6);
                }

                i.wz {
                    display: inline-block;
                    width: 40px;
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                    font-size: 1.2em;
                }

                .el-menu-item:hover, .el-menu-item.is-active, .el-menu-item.is-active:hover {
                    border-left: #fff 5px solid;
                    background: rgba(8, 108, 167, 0.6);
                    color: #fff !important;
                }

                .el-menu-item {
                    width: 170px;
                    padding-left: 35px !important;
                    border-left: transparent 5px solid;
                }

                .el-submenu__title i {
                    color: #fff;
                }

                &.toogleNav {
                    left: -170px;
                }
            }

            .slide {
                position: absolute;
                left: 156px;
                top: 50%;
                width: 14px;
                height: 40px;
                background: url(../assets/images/slide.png) no-repeat;
                z-index: 10;
                cursor: pointer;
                transition: all 0.3s ease-in-out;

                &.on {
                    left: 0;
                    transform: rotate(180deg);
                }
            }
        }

        .tabs-toogle .el-tabs__header {
            margin: 0;
        }
    }
</style>